import { client } from './client';

// --- Scheduled Actions (nested under service) ---

export const getActionsByService = async (serviceUid) => {
    const response = await client.get(`/v1/services/${serviceUid}/actions`);
    return response.data?.items ?? response.data;
};

export const createAction = async (serviceUid, data) => {
    const response = await client.post(`/v1/services/${serviceUid}/actions`, data);
    return response.data;
};

export const updateAction = async (uid, data) => {
    const response = await client.put(`/v1/actions/${uid}`, data);
    return response.data;
};

export const deleteAction = async (uid) => {
    const response = await client.delete(`/v1/actions/${uid}`);
    return response.data;
};

export const getActionRuns = async (uid) => {
    const response = await client.get(`/v1/actions/${uid}/runs`);
    return response.data?.items ?? response.data;
};
